import { SymbolName, Timestamp, TokenSymbol } from 'types'
import { ApiV1Response, http } from './http'

export interface ContractInformation {
  trade: string
  type: string
  baseCurrency: string
  marginCurrency: string
  quoteCurrency: string
  multiplier: number
  quoteMinimumIncrement: number
  quoteScale: number
  baseScale: number
  baseMinimumIncrement: number
  maximumQuantityPerOrder: number
  riskLimit: {
    id: number
    initialMarginRate: number
    maintenanceMarginRate: number
    marginRateStep: number
    maxLeverage: number
    riskLimitBase: number
    riskLimitStep: number
    maxRiskLimitSteps: number
    createdAt: number
  }
  settlementFeeRate: number
  markPrice: number
  markMethod: string
  currentFundingRate: number
  fundingInterval: number
  nextFundingTime: number
  nextFundingRate: number
  volume24H: number
  amount24H: number
  adlEnabled: string
  openInterest: string
}

export async function getContractInformation<
  G extends ApiV1Response<ContractInformation>
>(symbolName: SymbolName) {
  const r = await http
    .get<G>(`/market/contractInfo/${symbolName}`)
    .catch((e) => {
      return Promise.reject(e)
    })

  return r.data
}

export interface InsuranceFund {
  userId: number
  accountId: number
  amount: number
  createdAt: number
}
export async function getInsuranceFund<
  G extends ApiV1Response<InsuranceFund[]>
>() {
  const r = await http.get<G>(`/account/insurance/assets/stat`).catch((e) => {
    return Promise.reject(e)
  })

  return r.data
}

export type FundingRate = [Timestamp, number]
export async function getFundingRateHistory<
  G extends ApiV1Response<{ results: FundingRate[] }>
>(tokenSymbol: TokenSymbol) {
  const r = await http
    .get<G>(`/market/indexes/${tokenSymbol}_FR8H`)
    .catch((e) => {
      return Promise.reject(e)
    })

  return r.data
}
